// extracted by mini-css-extract-plugin
export default {"component":"Admin__component___cbnnW"};